import axios, { AxiosRequestConfig } from 'axios'
import { initCache, transformLanguage } from './utils'

import { Modules } from '../util/modules'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from '../config'

interface RetryConfig extends AxiosRequestConfig {
  retry: number
  retryDelay: number
}

Vue.use(VueI18n)
export const localizationKey = 'locale'
export enum Languages {
  English_US = 'en-US',
  Danish = 'da',
  German = 'de',
  Spanish = 'es',
  Finnish = 'fi',
  French_Canada = 'fr-CA',
  French_France = 'fr-FR',
  Italian = 'it',
  Dutch = 'nl',
  Norwegian = 'no',
  Portuguese_Brazil = 'pt-BR',
  Portuguese_Portugal = 'pt-PT',
  Swedish = 'sv',
}

export const retryConfig: RetryConfig = {
  retry: 4, // total 5 retries
  retryDelay: 1000
}

export const i18n = new VueI18n({
  locale: Languages.English_US,
  silentFallbackWarn: true,
})

axios.interceptors.response.use(undefined, err => {
  const { config, message } = err
  if (!config || !config.retry) {
    return Promise.reject(err)
  }
  // retry while Network timeout or Network Error
  if (!(message.includes('timeout') || message.includes('Network Error'))) {
    return Promise.reject(err)
  }

  --config.retry
  const delayRetryRequest = new Promise<void>(resolve => {
    setTimeout(() => {
      resolve()
    }, config.retryDelay || 1000)
  })
  return delayRetryRequest.then(() => axios(config))
})

// Will be cached till page-refresh
const { setCacheAndGetToLoad } = initCache()

export async function updateLocale(language: Languages, modules: Modules[] = [Modules.Common, Modules.SmartList, Modules.ContactDetail, Modules.Copilot]) {
  const transformedLanguage = transformLanguage(language)
  localStorage.setItem('locale', transformedLanguage)

  const modulesToLoad = setCacheAndGetToLoad(transformedLanguage as Languages, modules as Modules[])
  if (!modulesToLoad.length) {
    i18n.locale = transformedLanguage
    i18n.fallbackLocale = Languages.English_US
    return false
  }
  const localizationURL = `${config.localizationApiURL}/${transformedLanguage}/?module=${modulesToLoad.join(',')}`

  await axios
    .get(localizationURL, {
      ...retryConfig
    })
    .then(response => {
      const localJSONs = response.data
      i18n.locale = transformedLanguage
      i18n.fallbackLocale = Languages.English_US

      if (transformedLanguage !== Languages.English_US) {
        i18n.mergeLocaleMessage(transformedLanguage, localJSONs[transformedLanguage])
      }

      i18n.mergeLocaleMessage(Languages.English_US, localJSONs[Languages.English_US])
      //  Set status
    })
    .catch(error => {
      // Note: The 'error' is sent to Sentry after the API call is failed, even after retrying for 5 times
      console.error(
        `Err:: Translations failed to load for ${transformedLanguage}_${modulesToLoad.join(',')} -  ${JSON.stringify(
          error
        )}`
      )
      //  Set status
    })
}
